namespace TabAurous.ECommerce {
    export interface ECommSalesGiftVoucherForm {
        GiftMasterId: Serenity.LookupEditor;
        UniqueCode: Serenity.StringEditor;
        Value: Serenity.DecimalEditor;
        Amount: Serenity.DecimalEditor;
        Expiry: Serenity.DateEditor;
        Quantity: Serenity.IntegerEditor;
        IsPartial: Serenity.BooleanEditor;
    }

    export class ECommSalesGiftVoucherForm extends Serenity.PrefixedContext {
        static formKey = 'ECommerce.ECommSalesGiftVoucher';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ECommSalesGiftVoucherForm.init)  {
                ECommSalesGiftVoucherForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.DateEditor;
                var w4 = s.IntegerEditor;
                var w5 = s.BooleanEditor;

                Q.initFormType(ECommSalesGiftVoucherForm, [
                    'GiftMasterId', w0,
                    'UniqueCode', w1,
                    'Value', w2,
                    'Amount', w2,
                    'Expiry', w3,
                    'Quantity', w4,
                    'IsPartial', w5
                ]);
            }
        }
    }
}
